import { UtilService } from '@app/shared/services/util.service';
import { Component, Input, OnInit } from '@angular/core';
import { FormGroup} from '@angular/forms';

import { MatDialog, MatDialogRef } from '@angular/material/dialog';

import { TemposRppsService } from '@app/shared/services';

import { environment } from '@environments/environment';

import { AdicionarTempoRppsComponent } from '../adicionar-tempo-rpps/adicionar-tempo-rpps.component';

import { CargosEnum, Censo, ConfigCamposFormulario, Loading, SecretariasEnum, TempoRPPS } from '@app/shared/models';
import { distinctUntilChanged } from 'rxjs/operators';

@Component({
  selector: 'app-form-dados-funcionais',
  templateUrl: './form-dados-funcionais.component.html',
  styleUrls: ['./form-dados-funcionais.component.scss']
})
export class FormDadosFuncionaisComponent implements OnInit {

  @Input() formEtapa6: FormGroup;
  @Input() tempos: TempoRPPS[];
  @Input() segurado: any;
  @Input() configCamposFormulario: ConfigCamposFormulario[];
  @Input() configCamposFormulario_ETAPA_7: ConfigCamposFormulario[];
  @Input() censo: Censo;

  cliente = environment.cliente;
  cargos = new CargosEnum();
  secretarias = new SecretariasEnum();
  loading = new Loading();

  situacaoOutro: boolean;
  temAbono: boolean;
  temTeto: boolean;

  constructor(
    private temposRppsService: TemposRppsService,
    private utilService: UtilService,
    public dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.validarCamposCondicionaisDadosFuncionais();
  }

  private abrirDialog(tempo: TempoRPPS, listaTempos: TempoRPPS[]): MatDialogRef<AdicionarTempoRppsComponent> {
    return this.dialog.open(AdicionarTempoRppsComponent, {
      width: '800px',
      data: { tempo: tempo, listaTempos: listaTempos, segurado: this.segurado, configCamposFormulario: this.configCamposFormulario_ETAPA_7 },
      panelClass: 'custom-tempos-modal',
      closeOnNavigation: false,
      disableClose: true
    });
  }

  adicionarOuAtualizarTempo(tempo?: TempoRPPS): void {
    const dialogRef = this.abrirDialog(tempo, this.tempos);
    dialogRef.afterClosed().subscribe((result: TempoRPPS) => {
      if (result) {
        if (this.tempos.find(v => v.id === result.id)) {
          const index = this.tempos.findIndex(v => v.id === result.id);
          this.tempos[index] = result;
        } else {
          this.tempos.push(result);
        }
      }
    });
  }

  removerTempo(tempo: TempoRPPS): void {
    this.temposRppsService.excluirTempo(tempo.id, this.loading).subscribe(() => {
      const index = this.tempos.findIndex(v => v.id === tempo.id);
      this.tempos.splice(index, 1);
    });
  }

  /**
   *
   * @description Validacao condicional dos campos (Dados Funcionais)
   *
   */
  validarCamposCondicionaisDadosFuncionais(): void {
    this.formEtapa6.get('situacaoFuncional').valueChanges.pipe(distinctUntilChanged()).subscribe((value) => {
      this.situacaoOutro = value == 99
      this.utilService.alternarValidatorRequiredComDesativacao(this.formEtapa6.get('situacaoFuncionalOutro'), this.situacaoOutro);
    });

    this.formEtapa6.get('abonoPermanencia').valueChanges.pipe(distinctUntilChanged()).subscribe((value) => {
      this.temAbono = (value == 'true' || value == true)
      this.utilService.alternarValidatorRequiredComDesativacao(this.formEtapa6.get('abonoPermanenciaData'), this.temAbono);
    });

    this.formEtapa6.get('tetoRemuneratorio').valueChanges.pipe(distinctUntilChanged()).subscribe((value) => {
      this.temTeto = (value == 'true' || value == true)
      this.utilService.alternarValidatorRequiredComDesativacao(this.formEtapa6.get('tetoRemuneratorioValor'), this.temTeto);
    });
  }

  get verificarForm(): any {
    return this.utilService.verificarForm(this.formEtapa6);
  }

  isRequired(campo: string): any {
    return this.utilService.isRequiredField(campo, this.formEtapa6)
  }

  isVisible(campo: string): boolean {
    if (!this.configCamposFormulario) return null;

    const isVisible = this.configCamposFormulario.find((_: any) => _.nomeCampo == campo).visivel
    return isVisible;
  }
}
